import { useIntl } from 'react-intl'
import Modal from 'LuxKit/Modal/Modal'
import BodyText from 'LuxKit/Typography/BodyText'

interface Props {
  isOpen: boolean
  hotelName: string
  extraDays: number
  onClose: () => void
  onConfirm: () => void
}

function ExtendTripModal({
  isOpen,
  hotelName,
  extraDays,
  onClose,
  onConfirm,
}: Props) {
  const intl = useIntl()

  const extendTripTitle = intl.formatMessage({
    id: 'jG2gMDRTXLvlRVBfHapb',
    defaultMessage: 'Extend trip?',
    description: 'Modal title asking user to confirm extending trip dates',
  })
  const yesExtendLabel = intl.formatMessage({
    id: 'dHER0yy6l2liN9gO2zAw',
    defaultMessage: 'Yes, extend',
    description: 'Primary action button to confirm extending trip dates',
  })
  const keepDatesLabel = intl.formatMessage({
    id: '_xJaoUCZkNT_LUb3w07f',
    defaultMessage: 'No, keep the trip dates',
    description: 'Secondary action button to decline extending trip dates',
  })

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={extendTripTitle}
      primaryActionText={yesExtendLabel}
      onPrimaryActionClick={onConfirm}
      secondaryActionText={keepDatesLabel}
      onSecondaryActionClick={onClose}
    >
      <BodyText variant="large">
        {intl.formatMessage(
          {
            id: 'ZwyLeybTtwCCZx0zRNzu',
            defaultMessage: 'Your trip needs to be extended by {extraDays, plural, one {# day} other {# days}} to include the {hotelName}.',
            description: 'Message explaining how many days the trip needs to be extended to include a hotel',
          },
          { extraDays, hotelName },
        )}
      </BodyText>
    </Modal>
  )
}

export default ExtendTripModal
